module.exports = __webpack_public_path__ + "img/advantage.79bf3a9a.png";